import React from "react";
import { useLanguage } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative z-10 mt-24 border-t border-white/10 py-8">
      <div className="mx-auto max-w-7xl px-6 text-center md:px-10">
        <p data-testid="footer-initiative" className="text-xs leading-relaxed text-muted-foreground">
          {t("footer.initiative")}
        </p>
        <p className="mt-2 font-mono text-[10px] uppercase tracking-widest text-muted-foreground/60">
          © {year} Probably True
        </p>
      </div>
    </footer>
  );
}
